// Geri alınamayan işlemler için onay adımı.
//
// NEDEN VAR: SCADA anahtarını iptal etmek tek tıkla oluyordu ve etkisi anında
// sahaya vuruyor — o anahtarla gelen her paket 401 alıyor, sözleşme §2 gereği
// ajan onları ölü mektuba atıyor, yani yanlışlıkla basılan düğme SAHADAKİ
// VERİYİ SESSİZCE KAYBETTİRİYOR. Kalıcı silme de aynı şekilde onaysızdı.
//
// Kabuktaki çıkış onayı (Kabuk.tsx) kendi durumuna bağlı özel bir çekmece;
// burası `useDrawer()` üzerinden çağrılan genel karşılığı.

import { useState } from 'react'
import { DrawerAltlik, DrawerGovde, useDrawer } from './Drawer'

export default function OnayDrawer({
  soru,
  aciklama,
  onayEtiketi = 'Onayla',
  tehlikeli = false,
  onayla,
}: {
  /** Bir cümlelik "ne olacak" — bilgi kutusunda kalın basılır. */
  soru: string
  /** Sonucu anlatan ikinci cümle; ne geri alınamaz, neyi etkilemez. */
  aciklama: string
  onayEtiketi?: string
  /** Kırmızı düğme — yıkıcı işlemler için. */
  tehlikeli?: boolean
  /** Onaylanırsa çalışır; çekmece kendi kendini kapatır. */
  onayla: () => void | Promise<unknown>
}) {
  const { kapat } = useDrawer()
  const [bekliyor, setBekliyor] = useState(false)

  const calistir = async () => {
    setBekliyor(true)
    try {
      await onayla()
      kapat()
    } finally {
      // Hata durumunda çekmece AÇIK kalıyor: kullanıcı toast'ı görüp yeniden
      // deneyebilsin. Kapatsaydık başarısızlık sessizce geçerdi.
      setBekliyor(false)
    }
  }

  return (
    <>
      <DrawerGovde>
        <div className="info-box">
          <b>{soru}</b>
          <span>{aciklama}</span>
        </div>
      </DrawerGovde>

      <DrawerAltlik>
        <button className="btn btn-ghost" type="button" onClick={() => kapat()}>
          Vazgeç
        </button>
        <button
          className={tehlikeli ? 'btn btn-dan' : 'btn btn-pri'}
          type="button"
          style={{ flex: 1, justifyContent: 'center' }}
          disabled={bekliyor}
          onClick={() => void calistir()}
        >
          {onayEtiketi}
        </button>
      </DrawerAltlik>
    </>
  )
}
